export const createDateLocaleTheme = dateFnsLocale => ({
  components: {
    MuiEventCalendar: {
      defaultProps: {
        dateLocale: dateFnsLocale
      }
    },
    MuiEventTimeline: {
      defaultProps: {
        dateLocale: dateFnsLocale
      }
    }
  }
});